import { User } from 'src/common-services/types/user-types'

export type DocumentResponse = {
  id: string
  group: string
  parent: string | null
  title: string
  data: any
  permissions: DocumentPermissions
  created: { name: string; on: Date }
  updated: { name: string | null; on: Date | null }
}

export type DeleteDocumentResponse = { success: boolean }
export type DeleteDocumentPermissionResponse = { success: boolean }

export type DocumentListItem = {
  id: string
  group: string
  parent: string | null
  title: string
  permissions: DocumentPermissions
  created: { name: string; on: Date }
  updated: { name: string | null; on: Date | null }
  v2?: boolean
}

export type DocumentListResponse = DocumentListItem[]

export type FullDocumentListResponse = DocumentResponse[]

export type DocumentPermissionResponse = {
  id: string
  user: { userId: User['id']; name: string }
  documentId: string
  permissions: DocumentPermissions
  created: { name: string; on: Date }
  updated: { name: string | null; on: Date | null }
}
export type DocumentPermissionListResponse = DocumentPermissionResponse[]

export type CreateDocumentRequest = { id: string; group: string; parent?: string; title: string; data: any }
export type ListDocumentsRequest = { group: string; parent?: string; limit?: number; offset?: number }
export type LimitListDocumentsRequest = { limit?: number; offset?: number }
export type GetDocumentRequest = { id: string }
export type DeleteDocumentRequest = { id: string }
export type UpdateDocumentRequest = { id: string; deleted: boolean } & CreateDocumentRequest
export type PatchDocumentRequest = {
  id: string
  group?: string
  parent?: string
  title?: string
  data?: any
  deleted?: boolean
}
export type CreateDocumentPermissionRequest = {
  id: string
  email: string
  documentId: string
  permission: DocumentPermissions
}
export type ListDocumentPermissionsRequest = { documentId: string }
export type UpdateDocumentPermissionRequest = {
  id: string
  documentId: string
  permissions: DocumentPermissions
}
export type DeleteDocumentPermissionRequest = { id: string; documentId: number }

export enum DocumentPermissions {
  NONE = 0,
  READ = 1,
  WRITE = 2,
  ADMIN = 4,
}
